/**
 * This component computes and renders article reading time via js.
 */
if (!customElements.get('article-read-time')) {
    class ArticleReadTime extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            document.addEventListener('DOMContentLoaded', this.renderArticleReadTimes.bind(this));
        }

        renderArticleReadTimes() {
            this.articleJSON = this.querySelector('[type="application/json"]');
            if (!this.articleJSON) return;

            this.article = JSON.parse(this.articleJSON.textContent);

            this.readTime = Math.floor(
                this.article.body_html
                    .replace(/(<([^>]+)>)/gi, '')
                    .trim()
                    .split(' ').length / 240
            );

            this.textContent = '';

            const label = document.createElement('span');
            label.textContent = `${this.readTime == 0 ? 1 : this.readTime} MIN`;
            label.setAttribute('aria-hidden', true);

            const srLabel = document.createElement('span');
            srLabel.classList.add('sr-only');
            srLabel.textContent = `read for ${this.readTime == 0 ? 1 : this.readTime} ${this.readTime <= 1 ? 'minute' : 'minutes'}`;

            this.appendChild(label);
            this.appendChild(srLabel);
        }
    }

    customElements.define('article-read-time', ArticleReadTime);
}
